<template>
  <div class="about">
    <!-- 顶部组件 -->
    <top-navigation></top-navigation>
    <!-- banner部分 -->
    <div class="banner"></div>
    <!-- block_1 -->
    <div class="block_1">
      <div class="center_box">
        <div class="left_text">
          <b>北京卓闻数据科技有限公司</b>
          （简称：卓闻数据）“卓闻数据”成立于2020年12月，由一批中国品牌学界的学者们共同倡议、组建研发团队、与专业运营机构联袂创立。
            <br>
            <p>“卓闻数据”汇集了一批国内品牌管理科学领域的高水平人才，并与其他顶尖研究机构合作，充分利用互联网、大数据技术手段，创建“填呗数据采集平台”、“卓闻数据 · 全球品牌数据库”、“中国品牌数字化运营中心”等平台，助力中国迎接品牌数字化时代，推动中国品牌数字化发展。</p>
        </div>
        <img src="../../assets/image/about/info_bg.png" alt="" />
      </div>
    </div>
    <!-- block_2 -->
    <div class="block_2">
      <div class="text_box">
        <span class="t1">公司价值与业务单元</span>
        <span class="line"></span>
        <span class="t2">
          卓闻数据拥有“填呗”App数据采集平台、计算系统、统计分析系统、评价系统、可视化集成系统等模块，从协助客户收集问卷的简单业务，到帮助客户建立大型标准化品牌数据库的复杂项目，卓闻数据在全链条支持每位用户的需求。</span
        >
        <span class="t2">
          卓闻数据建设全球品牌数据库，致力于满足学术界科研院所、高校师生等对品牌数据的需求，满足各类企业对市场研究和经营决策的需要，为各级政府的品牌数字化平台提供高效精准的依据。</span
        >
      </div>
      <!-- <div class="block_img_box"></div>
      <div class="block_img_box_2"></div> -->
      <div class="imageBox">
        <div class="_box">
          <a href="https://zhuowen.oss-cn-beijing.aliyuncs.com/file/%E5%A1%AB%E5%91%97%E9%87%87%E9%9B%86%E5%B9%B3%E5%8F%B0.pdf" target="_blank">
            <img src="../../assets/image/about/sjcjpt.png" alt="">
            <div class="text">数据采集平台</div>
          </a>
        </div>
        <div class="_box">
          <a href="https://mp.weixin.qq.com/s/cUY-JuYvtuSxA2joj40exQ" target="_blank">
            <img src="../../assets/image/about/jstj.png" alt="">
            <div class="text">全球品牌资源数据库</div>
          </a>
        </div>
        <div class="_box">
          <img src="../../assets/image/about/kshjc.png" alt="">
          <div class="text">中国品牌数字化平台</div>
        </div>
      </div>
      <div class="imageBox_1">
        <div class="box_1"></div>
        <div class="box_2">
          <div class="box_left">
            <img src="../../assets/image/about/imageBanner.png" alt="">
          </div>
          <div class="box_right">
            <!-- <img src="../../assets/image/index/logo.png" alt=""> -->
            <div class="box_title">卓闻使命</div>
            <div class="box_titletwe" style="font-size:18px;">致力于中国品牌数字化建设</div>
            <div class="box_centOne">卓闻数据拥有数据采集、辅助计算、分析平台及对外开放的数据存储和可视化系统，提供全国品牌的数据调研、统计服务，以及品牌研究学术资源的查询等服务，优化企业品牌管理的科学实践、满足学术界对品牌研究的数据需求。</div>
            <div class="box_cent">卓闻数据以推动中国品牌的发展为己任，着力于品牌管理科学领域的前瞻性基础研究和引领性原始创新。</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部组件 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../../components/footer/footer.vue";
import topNavigation from "../../components/topNavigation/topNavigation.vue";
export default {
  components: { topNavigation, Footer },
  created() {
    window.scrollTo(0, 0); // 回滚
  },
};
</script>

<style scoped lang='less'>
@media screen and (min-width: 0px) and (max-width: 1440px) {
  .mt {
    width: 1440px;
    margin: 0 auto;
  }
  .about {
    min-width: 1440px;
  }
}
@media screen and (min-width: 1441px) and (max-width: 1920px) {
  .mt {
    width: 1680px;
    margin: 0 auto;
  }
  .about {
    min-width: 1680px;
  }
}


.about {
  background-color: #fff;
  .banner {
    width: 100%;
    height: 460px;
    background: url("../../assets/image/about/about_banner.png") no-repeat
      center center;
  }
  .text_box {
    width: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    .t1 {
      font-size: 24px;
      line-height: 32px;
      color: #427bd5;
    }
    .line {
      margin-top: 12px;
      width: 118px;
      height: 4px;
      background: #427bd5;
      border-radius: 2px;
    }
    .t2 {
      width: 1276px;
      margin-top: 18px;
      font-size: 18px;
      line-height: 26px;
      color: #666666;
      text-indent: 2em;
    }
  }
  .block_1 {
    width: 100%;
    padding: 32px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    .center_box {
      display: flex;
      align-items: center;
      .left_text {
        width: 530px;
        font-size: 16px;
        line-height: 28px;
        color: #333333;
        text-indent: 2em;
        b {
          font-size: 24px;
          font-weight: bold;
          color: #427bd5;
        }
      }
      img {
        width: 600px;
        height: 280px;
        margin-left: 70px;
      }
    }
  }
  .block_2 {
    width: 100%;
    padding: 38px 0 52px;
    box-sizing: border-box;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    .block_img_box {
      margin-top: 60px;
      width: 1050px;
      height: 144px;
      background: url("../../assets/image/about/yw_bg.png") no-repeat;
      background-size: contain;
    }
    .block_img_box_2 {
      margin-top: 72px;
      width: 1200px;
      height: 452px;
      background: url("../../assets/image/about/yw_bg_2.png") no-repeat;
      background-size: contain;
    }
    .imageBox {
      width: 1200px;
      margin-top: 60px;
      display: flex;
      justify-content: space-between;
      ._box {
        text-align: center;
        img {
          margin-bottom: 35px;
        }
        .text {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 33px;
        }
      }
    }
    .imageBox_1 {
      margin-top: 72px;
      width: 100%;
      height: 420px;
      position: relative;
      .box_1 {
        width: 100%;
        height: 140px;
        background-color: #F9F9F9;
        position: absolute;
        bottom: 20px;
        left: 0;
      }
      .box_2 {
        width: 1200px;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%,0);
        .box_left {
          float: left;
        }
        .box_right {
          float: left;
          img {
            position: absolute;
            top: 70px;
            left: 73%;
            transform: translate(-50%,0);
          }
          .box_title {
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #427BD5;
            line-height: 32px;
            position: absolute;
            top: 40px;
            left: 42%;
          }
          .box_titletwe {
            font-size: 22px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #427BD5;
            line-height: 32px;
            position: absolute;
            top: 80px;
            left: 42%;
          }
          .box_centOne {
            width: 955px;
            margin-top: 18px;
            padding: 20px 135px 20px 20px;
            font-size: 18px;
            line-height: 26px;
            color: #666666;
            position: absolute;
            top: 115px;
            left: 40.6%;
            background-color: #F9F9F9;
          }
          .box_cent {
            width: 612px;
            margin-top: 18px;
            font-size: 18px;
            line-height: 26px;
            color: #666666;
            position: absolute;
            top: 285px;
            left: 42%;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/about/about.vue